export default "__VITE_ASSET__CJhR48ie__$_?=raw__"